(function () {
    let connectedProductsContainer = document.querySelector(
      ".pdp-connected-products-container"
    );
    if (!connectedProductsContainer) return;
    const currentProduct = JSON.parse(connectedProductsContainer.dataset.product);
    const currentVariants = currentProduct.variants.map((v) => ({
      option1: v.option1,
      available: v.available,
    }));
  let productVariants=document.querySelectorAll(".product-form__controls-group input[type='radio']")
  if (!productVariants) return;
  productVariants.forEach((input) => {
        input.addEventListener("change", () => {
          checkAvailability(input.value);
        });
      });
    function checkAvailability(value) {
      let connectedProductsElement=document.querySelectorAll(".pdp-connected-product")
      if (!connectedProductsElement) return;
      connectedProductsElement.forEach((el, index) => {
        const connectedProductData = el.dataset.connectedProduct;
        if (!connectedProductData) return;
        el.classList.remove("sold-out");
        let connectedProduct;
  
        try {
          connectedProduct = JSON.parse(connectedProductData);
        } catch (e) {
          console.warn("Invalid connected product JSON", e);
          return;
        }
  
        if (connectedProduct.id === currentProduct.id) {
          connectedProduct.variants.forEach((variant, index) => {
            if (variant.option1 === value) {
              if (variant.option1 === currentVariants[index].option1) {
                if (!currentVariants[index].available) {
                  variant.available = false;
                  el.classList.add("sold-out");
                }
              }
            }
          });
        }
      });
    }
  })();